import React, { useState,useEffect } from "react";
import { PaymentElement as PaymentElementDevelopment, useXpay as useXpayDevelopment } from "@xstak/xpay-element-stage-v2";
import { PaymentElement as PaymentElementProduction, useXpay as useXpayProduction } from "@xstak/xpay-element-live-v2";
import api from "src/utils/axios";
import { useSelector } from "react-redux";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router";
import { Box, Button, Stack, TextField } from "@mui/material";
import { useSnackbar } from "../components/snackbar";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useDispatch } from "react-redux";
import { fRound } from "src/utils/formatNumber";
import { socket } from "src/App";
import Iconify from "src/components/iconify/Iconify";

const getToken = localStorage.getItem("access_token");


export const Payment = ({ total, selectedSlot, occasion, specialRequest, totalAmountPaid,timeLeft }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { user, isLoggedIn } = useSelector((state) => state.login);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [filledAllCardDetails, setFilledAllCardDetails] = useState(false);
  const [saveCardInfo, setSaveCardInfo] = useState(false);


  const [error, setError] = useState("")

  const [cardNetwork, setCardNetwork] = useState("");
  const [cardLastDigits, setCardLastDigits] = useState("");
  const [cardStartDigits, setCardStartDigits] = useState("");
  const [selectedCardOption, setSelectedCardOption] = useState(null);

  const options = {
    override: true,
    fields: {
      creditCard: {
        placeholder: "4234 1234 1234 1234",
        label: "Enter your credit card",
      },
      exp: {
        placeholder: "Exp. Date",
      },
    },
    style: {
      ".input": {
        border: "1px solid black",
        "border-radius": "15px",
      },
      ".invalid": {},
      ".label": {
        "font-size": "18px",
      },
      ":focus": {},
      ":hover": {},
      "::placeholder": {},
      "::selection": {},
    },
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = String(date.getUTCFullYear());

    return `${year}-${month}-${day}`;
  }
  const handleChange = (event) => {
    setSaveCardInfo(event.target.checked);
  };
  useEffect(() => {
    if (user?.savedCardsInformation?.length > 0) {
      setSelectedCardOption(0)
    }
  }, [user]);
  const handleChangeSavedCards = (index) => {
    setSelectedCardOption(index);
  };


  const pay = async () => {
    setIsLoading(true);
    const customer1 = { name: `${user?.firstName}`, email: user?.email, phone: user?.phone }
    let totalAmount
    if (total?.type === 'fixed') {
      if (total?.amount > totalAmountPaid) {
        let amonuntWhichGet = total?.amount - totalAmountPaid
        totalAmount = amonuntWhichGet
      } else {
        totalAmount = total?.amount
      }
    } else if (total?.type === "perPerson") {
      if (total?.amount * selectedSlot?.selectedTableSize > totalAmountPaid) {
        let amonuntWhichGet = total?.amount * selectedSlot?.selectedTableSize - totalAmountPaid
        totalAmount = amonuntWhichGet
      } else {
        totalAmount = total?.amount * selectedSlot?.selectedTableSize
      }
    } else {
      totalAmount = total?.amount
    }

    try {
      const shipping = {
        address1: "abc",
        city: "Islamabad",
        country: "Pakistan",
        phone: "03415555555",
        zip: "12345",
        shipping_method: "Standard",
      };


      let dataForCreateIntent = {
        partySize: parseInt(selectedSlot?.selectedTableSize, 10),
        date: formatDate(selectedSlot?.selectedSlot?.startingTime),
        venueId: selectedSlot?.selectedSlot?.venueId,
        levelId: selectedSlot?.selectedSlot?.levelId,
        startTime: selectedSlot?.selectedSlot?.startingTime,
        endTime: selectedSlot?.selectedSlot?.endingTime,
        tableId: selectedSlot?.selectedSlot?.tableId,
        areaId: selectedSlot?.selectedSlot?.areaId?.id,
        slotUniqueId: "6735df21e3a4ab3834086886",
        customerId: user?.id,
        origin: "web",
        amount: fRound(totalAmount, 2),
        currency: "PKR",
        payment_method_types: "card",
        shipping: shipping,
        reservationType: "online",
        shipping: shipping,
        saveCardInfo: saveCardInfo,
        payment_method_types: "card",
        occasion: occasion,
        specialRequest: specialRequest,
        card: {
          cardNetwork: cardNetwork,
          cardLastDigits: cardLastDigits,
          cardStartDigits: cardStartDigits
        }
      }

      if (selectedCardOption != null) {
        dataForCreateIntent.payment_method_types = "token";
        dataForCreateIntent.tokenId = user?.savedCardsInformation[selectedCardOption]._id
        dataForCreateIntent.customerId = user.id
      }
      let reScheduleAPI = `${process.env.REACT_APP_BACKEND_URL}/reservation/${selectedSlot?.detail?.id}/reScheduleReservation/b2c`
      let createAPI = `${process.env.REACT_APP_BACKEND_URL}/reservation/b2c`;
      let selectedAPi = createAPI;
      if (selectedSlot?.detail?.id) {
        selectedAPi = reScheduleAPI;
        dataForCreateIntent.isPaymentRequired = true;
        dataForCreateIntent.previouslyPaidAmount=1000
      }
      let paymentIntentResponse 
       paymentIntentResponse = await api.post(
        selectedAPi, dataForCreateIntent,
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }

      );
   
      if (paymentIntentResponse.data.response.success == true) {
        const { pi_client_secret, encryptionKey } =
          paymentIntentResponse.data.response.data;
        try {
          let message = null;
          let error = null;
          if (selectedCardOption == null) {
            const result = await xpay.confirmPayment(
              "card",
              pi_client_secret,
              customer1,
              encryptionKey
            );
            message = result.message;
            error = result.error;
          }
          if (error) {
            setIsLoading(false);
            enqueueSnackbar("Payment Failed!");
            throw new Error(`Payment failed!: ${error}`);
          } else if (selectedCardOption == null || !error) {
            let updateReservationData = {
              reservationId: paymentIntentResponse.data.reservation.id,
              paymentIntent: paymentIntentResponse.data.response.data._id,
              transactionId: paymentIntentResponse.data.transaction.id,
              saveCardInfo: saveCardInfo,
            }

            if (saveCardInfo) {
              updateReservationData.cardNetwork = cardNetwork;
              updateReservationData.cardLastDigits = cardLastDigits
              updateReservationData.cardStartDigits = cardStartDigits
            }

            let updateReservationResponse  
            if(selectedSlot?.detail?.id) {
              updateReservationResponse =  await api.patch(
               `${process.env.REACT_APP_BACKEND_URL}/reservation/${selectedSlot?.detail?.id}/reSchedulePaymentSuccess/b2c`,
                {
                  date: formatDate(selectedSlot?.selectedSlot?.startingTime),
                  partySize: parseInt(selectedSlot?.selectedTableSize, 10),
                  startTime: selectedSlot?.selectedSlot?.startingTime,
                  endTime: selectedSlot?.selectedSlot?.endingTime,
                  paymentIntent: paymentIntentResponse.data.response.data._id,
                  transactionId: paymentIntentResponse.data.transaction.id,
                  saveCardInfo: saveCardInfo,
                }
              );
            }else {
              updateReservationResponse =  await api.patch(
                `${process.env.REACT_APP_BACKEND_URL}/reservation/paymentSuccess/b2c`,
                updateReservationData
              );
            }

            if (updateReservationResponse.error) {
              setIsLoading(false);
              enqueueSnackbar("Payment Failed!", { variant: "error" });
              throw new Error(`Order update failed: ${updateReservationResponse.error}`);
            } else {
              setIsLoading(false);
              socket.emit("newReservation", { reservation: { ...updateReservationResponse.data } });
              navigate("/reservation");
            }
          }
        } catch (error) {
          if (selectedSlot?.detail?.id) {
            await api.patch(`${process.env.REACT_APP_BACKEND_URL}/reservation/${selectedSlot?.detail?.id}/reSchedulePaymentFailed/b2c`,
              {
                transactionId: paymentIntentResponse.data.transaction.id,
                message: error.message
              }
            )
          } else {
            await api.patch(
              `${process.env.REACT_APP_BACKEND_URL}/reservation/paymentFailed/b2c/`,
              {
                reservationId: paymentIntentResponse.data.reservation.id,
                transactionId: paymentIntentResponse.data.transaction.id,
                message: error.message
              }
            );
        }
          enqueueSnackbar("Payment Failed!", { variant: "error" });
          setIsLoading(false);
          setError(error?.response?.data?.message);
        }
      } else {
        setIsLoading(false);
        enqueueSnackbar("Payment Failed!", { variant: "error" });
        throw new Error("Payment Intent creation failed");
      }
    } catch (error) {
      setError(error?.response?.data?.message);
      console.error("Error during payment process:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };


  const useXpay = process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === "staging" ? useXpayProduction : useXpayDevelopment;
  const PaymentElement = process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === "staging" ? PaymentElementProduction : PaymentElementDevelopment;
  const xpay = useXpay();

  return (
    <>
      <Box p={"12px"}>

        {" "}
        <div>
          <Stack
            alignItems="flex-start"
            sx={{
              width: 1,
            }}
          >
            {user?.savedCardsInformation?.length > 0 && selectedCardOption !== null &&
              <TextField
                select
                fullWidth
                label="Card"
                sx={{ marginBottom: selectedCardOption != null ? "0" : "20px" }}
                SelectProps={{
                  native: true,
                }}
              >
                {user?.savedCardsInformation?.map((card, index) => (
                  <option key={card.value} value={index}
                    checked={selectedCardOption === index}
                    onClick={() => { handleChangeSavedCards(index) }}>
                    **** **** **** {card.lastDigits}
                  </option>
                ))}
              </TextField>
            }
            {(selectedCardOption != null) &&
              <Button
                size="small"
                startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => { setSelectedCardOption(null) }}
                sx={{ my: 3 }}
              >
                Add new card
              </Button>
            }
            {(user?.savedCardsInformation?.length > 0 && selectedCardOption == null) &&
              <Button
                size="small"
                onClick={() => { setSelectedCardOption(0) }}
                sx={{ mb: 2 }}
              >
                use save card
              </Button>
            }
          </Stack>
        </div>
        {
          (selectedCardOption == null) &&
          <PaymentElement
            options={options}
            onBinDiscount={(event) => {

              setCardLastDigits(event?.data?.last4digts ?? null)
              setCardStartDigits(event?.data?.bin ?? null)
              setCardNetwork(event?.data?.card_network ?? null)
              // console.log("bin details", event);
            }}
            onReady={(event) => {
              setFilledAllCardDetails(event.ready);
              // console.log("ready event", event);
            }}
          />
        }
        {(filledAllCardDetails || (selectedCardOption != null)) && (
          <LoadingButton
            fullWidth
            color="inherit"
            size="large"
            type="submit"
            variant="contained"
            loading={isLoading}
            onClick={pay}
            disabled={!user?.isPhoneVerified && isLoggedIn || timeLeft<=0 }
            sx={{
              bgcolor: "#fda92d",
              color: (theme) =>
                theme.palette.mode === "black" ? "common." : "grey.800",
              "&:hover": {
                bgcolor: "#B66816",
                color: (theme) =>
                  theme.palette.mode === "black" ? "common.white" : "grey.800",
              },
            }}
          >
            Pay Now
          </LoadingButton>
        )}

        {isLoggedIn && filledAllCardDetails &&
          <FormControlLabel
            control={
              <Checkbox
                checked={saveCardInfo}
                onChange={handleChange}
                name="myCheckbox"
                color="primary"
                sx={{ marginLeft: '2px' }}
              />
            }
            label="Save the Card For Future Use!"
          />
        }

      </Box>
    </>
  );
};
